var render, staticRenderFns
import script from "./HighlightSection.vue?vue&type=script&lang=tsx"
export * from "./HighlightSection.vue?vue&type=script&lang=tsx"
import style0 from "./HighlightSection.vue?vue&type=style&index=0&id=28a42e40&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a42e40",
  null
  
)

export default component.exports